module.exports = "fragment Departement on DepartementType{__typename id name code:codeDept region{__typename id name}oldRegion{__typename id name}}"